import React from 'react';

import {
  ScrollView,
  View,
} from 'react-native';

import * as _hm from './_hm';
import * as _ht from './_ht';
import * as _cr from './_cr';

import { a } from './_cmABT';

export type tSrlCz = {
  abtz?: _ht.dz, 
  srlStlz?: _ht.dz,
  srlPtyz?: _ht.dz,
  srlClds: _ht.ls,
};

const $grtAbtz = (pz?: {
  type?: _ht.s,
}) => {
  switch (pz?.type) {
    default:
      return {
        srlStlz: {
//          otrz: a("dw/f"),
//          inrz: a("dw/f fd/css"),
        },
        srlPtyz: undefined,
      }
  }
};

/*
export type tScrollViewRef = ScrollView & {
    flashScrollIndicators: () => void;
};
*/

export const N = (pz: tSrlCz) => {

/*
  const _rrc = React.useRef<tScrollViewRef | null>(null);

  React.useEffect(() => {
    setTimeout(function () {
      _rrc.current?.flashScrollIndicators();
    }, 500);
  }, []);
*/

//  const _abtz = $grtAbtz(pz.abtz);
  return (
    _cr.c(ScrollView, {
//        horizontal: false,

//        showsHorizontalScrollIndicator: true,
//        showsVerticalScrollIndicator: true,
//        persistentScrollbar: true,
//        ref: _rrc,
//      ... pz.srlPtyz,
      style: {
        /*
          scrollview の height は、flex 適用不可であり、直接 height を指定する必要があるとのこと
          https://stackoverflow.com/questions/49373417/react-native-scrollview-height-always-stays-static-and-does-not-change
        */
        ... a('dh/0 dw/f'),
        ... pz.srlStlz?.otrz,
      },
      contentContainerStyle: {
        ... a('dw/f fd/csc'),
        ... pz.srlStlz?.inrz,
      },
    }, 
      pz.srlClds
    )
  );
};

export const M = React.memo((pz: { // Marquee
  boxStlz: _ht.dz,
  cz?: {
    spd: _ht.n,
    wait: _ht.n,
  },
  clds: _ht.ls
  srlStlz: _ht.dz,
}) => {

  const _rThis = React.useRef<null | ScrollView>(null);

  return (
    _cr.c(View, { // ScrollView の height 指定に必要
      key: 'Mrq.root',
      style: {
        ... a('dw/f p/1'),
        ... pz.boxStlz,
      }
    },
      _cr.c(ScrollView, {
        key: -10,
        ref: _rThis,
        style: {
          ... a('dh/0 dw/f'),
          ... pz.srlStlz?.otrz,
        },
        contentContainerStyle: {
          ... a('dw/f fd/csc'),
          ... pz.srlStlz?.inrz,
        },
        onLayout: async ( _dz: _ht.dz ) => {
          const _w = _dz.nativeEvent.layout.width;
//          const _nWait = pz.crlz.nWait ?? 5000;
          const _wait = pz.cz?.wait ?? 5000;
          let _x = 0;
          for (;;) {
            if ( _x == 0 ) await _hm.waitAsync(_wait); // 少し待機
            _x += pz.cz?.spd ?? 1;
            _rThis?.current?.scrollTo({ x: _x, animated: true})
            if ( _x >= _w ) {
              await _hm.waitAsync(_wait); // 少し待機
              _x = 0;
              _rThis?.current?.scrollTo({ x: _x, animated: false})
            }
            await _hm.waitAsync(100); // 短すぎるとアニメーションが追いつかないため、100 固定
          }
        },
        horizontal: true,
        showsHorizontalScrollIndicator: false,
      }, 
/*
        _hm.getRng(10).map( () => {
          return pz.oClds;
        })
*/
        pz.clds,
      )
    )
  );

});
